import { createSelector, Dispatch } from '@reduxjs/toolkit';
import { closeOverlay, OverlayType, selectReviewOverlayVisible } from 'store/slice/overlay';
import { selectCmsFromBootstrap, selectExperimentsFromBootstrap } from 'store/slice/bootstrap';
import { CmsValue } from 'core/type/BootstrapConfig.types';
import { selectReviewState } from 'component/page/detail/store/detail.selectors';
import { ExperimentId } from 'core/type/ExperimentId';
import { isB } from 'core/window/bootstrapConfig';
import { trackElementEvent } from 'core/messaging/analytics/analytics';
import { ActivitiesCloseCustomSheetClickEventActivitiesFieldsV1 } from '@agoda/analytics-messages-definition-activities/events.split';
import { ActivitiesCloseCustomSheetClickEventActivitiesManifestV1 } from '@agoda/analytics-messages-definition-activities/manifest/events';

export interface StateProps {
    isReviewOverlayVisible: boolean;
    cms: CmsValue;
    isLoading: boolean;
    isError: boolean;
    isDroneSheet: boolean;
}

export interface DispatchProps {
    closeReviewOverlay: () => void;
    onClickBackReviewOverlay: () => void;
}

export type Props = StateProps & DispatchProps;

export const mapStateToProps = createSelector(
    selectReviewOverlayVisible,
    selectCmsFromBootstrap,
    selectExperimentsFromBootstrap,
    selectReviewState,
    (isReviewOverlayVisible, cms, experiments, state): StateProps => {
        return {
            isReviewOverlayVisible,
            cms,
            isLoading: state.isLoading,
            isError: state.isError,
            isDroneSheet: isB(ExperimentId.ACT_4452, experiments),
        };
    },
);

export const mapDispatchToProps = (dispatch: Dispatch): DispatchProps => ({
    closeReviewOverlay: () => {
        dispatch(closeOverlay(OverlayType.Review));
    },
    onClickBackReviewOverlay: () => {
        trackElementEvent<ActivitiesCloseCustomSheetClickEventActivitiesFieldsV1>(ActivitiesCloseCustomSheetClickEventActivitiesManifestV1.ids, {});
        dispatch(closeOverlay(OverlayType.Review));
    },
});
